import { useMutation, useQueryClient } from "@tanstack/react-query";

import { post } from "common/helpers/HTTP";

import { getDeploymentDomain } from "../utils";

async function addDeploymentAliasRequest(domainName: string): Promise<string> {
  //alias the domain
  return (
    await post(`agency/domains/${getDeploymentDomain()}/deployment/aliases`, {
      alias: domainName,
    })
  ).record.alias;
}

export default function useDeploymentAliasesMutations() {
  const queryClient = useQueryClient();

  const {
    mutateAsync: addDeploymentAlias,
    isPending: isAddingDeploymentAlias,
  } = useMutation({
    mutationFn: ({ domainName }: { domainName: string }) =>
      addDeploymentAliasRequest(domainName),
    onSuccess: (alias) => {
      queryClient.setQueryData<string[]>(
        ["deploymentAliases"],
        (prevAliases) => [...prevAliases, alias],
      );
    },
  });

  return {
    addDeploymentAlias,
    isAddingDeploymentAlias,
  };
}
